__turbopack_context__.v({
  "avatar": "_5yrKyG_avatar",
  "avatar--size-tiny": "_5yrKyG_avatar--size-tiny",
});
